(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateTicketDashboard', MigrateTicketDashboard);

    MigrateTicketDashboard.$inject = ['$resource'];

    function MigrateTicketDashboard ($resource) {
        var resourceUrl =  '/api/migrateMinMaxData';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
